import {User} from '../interfaces/User';
import {Permission} from '../interfaces/Permission';
import {Role} from '../interfaces/Role';

export class UserModel implements User {

  public id: number;
  public name: string;
  public email: string;
  public airport_id?: number;
  public region_id?: number;
  public permissions: Permission[];
  public level: number;

  public roles: Role[];

  constructor(user: User) {
    for (const key in user)
      if (user.hasOwnProperty(key))
        this[key] = user[key];
  }

  /**
   * Determine if this user can do the following permission
   * @param {string|string[]} permissions
   * @returns {boolean}
   */
  public can(permissions: string|string[]) {
    // check if all permissions can be performed
    if (Array.isArray(permissions)) {
      for (const permission of permissions)
        if (!this.can(permission))
          return false;
      return true;
    }
    // if permissions is a single string return if the user can perform that action
    return Boolean(this.permissions.find((t) => t.name === permissions));

  }

  public hasRole(role: string) {
    for (const rol of this.roles)
      if (rol.name === role)
        return true;
    return false;
  }


}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/user/models/UserModel.ts